module.exports = " <form @submit.prevent=signIn _v-65b7f667=\"\"> <div class=form-group _v-65b7f667=\"\"> <input type=text v-model=accessTokenInput placeholder=请输入access_token _v-65b7f667=\"\"> </div> <button type=submit _v-65b7f667=\"\">登录</button> </form> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-65b7f667!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/vLogin.vue
 ** module id = 95
 ** module chunks = 2
 **/